import { render, staticRenderFns } from "./UpdateSupplierDeduction.vue?vue&type=template&id=5ec9da7c&scoped=true"
import script from "./UpdateSupplierDeduction.vue?vue&type=script&lang=ts"
export * from "./UpdateSupplierDeduction.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec9da7c",
  null
  
)

export default component.exports